'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _authorisation = _interopRequireDefault(require("../authorisation"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var GitChangesetLink = /*#__PURE__*/function (_React$Component) {
  _inherits(GitChangesetLink, _React$Component);

  function GitChangesetLink(props) {
    _classCallCheck(this, GitChangesetLink);

    return _possibleConstructorReturn(this, (GitChangesetLink.__proto__ || Object.getPrototypeOf(GitChangesetLink)).call(this, props));
  }
  /**
   *
   * @returns {*}
   */


  _createClass(GitChangesetLink, [{
    key: "render",
    value: function render() {
      var classNames = this.props.small ? 'git-link git-link__small' : 'git-link';
      if (this.props.changesetUrl.length === 0) return '';
      return /*#__PURE__*/_react.default.createElement("a", {
        href: this.props.changesetUrl,
        title: this.props.text,
        className: classNames,
        target: '_blank',
        rel: 'noopener'
      }, this.props.small ? '' : this.props.text);
    }
  }]);

  return GitChangesetLink;
}(_react.default.Component);

GitChangesetLink.defaultProps = {
  small: false,
  changesetUrl: ''
};
GitChangesetLink.propTypes = {
  changesetUrl: _propTypes.default.string.isRequired,
  text: _propTypes.default.string.isRequired,
  small: _propTypes.default.bool
};

var _default = new _authorisation.default(['admin'], [], false)(GitChangesetLink);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/git-changeset-link/index.js
// module id = 57
// module chunks = 0